// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bfca6744","703":"a24ba706","787":"618072b9"}[chunkId] + ".chunk.js";
};